export class UDR {
  id?: string;
  displayName?: string;
  displayOrder?: number;
  parentUdrId?: string;
  type?: string;
  children?: UDR[];
}
